export const TAB_OPTIONS = [
  { name: 'Overview', route: '' },
  { name: 'Growth plan', route: 'growth' },
  { name: 'Documents', route: 'documents' },
  { name: 'Insights', route: 'insights' },
  { name: 'Sessions', route: 'sessions' },
  { name: 'Profile', route: 'profile' },
  { name: 'Internal Notes', route: 'notes' },
];
